import {
  acceptedClosedConfig,
  acceptedOpenConfig,
  allConfig,
  inReviewConfig,
  needsActionConfig,
  pendingConsentConfig,
} from './sentReferralsConfigs';

function getReferralColumnConfig(
  routeStatus,
  statuses = [],
  actions = [],
  isSuperNetwork,
  currentSort,
  onSortColumn,
  showProgramNameColumn,
) {
  switch (routeStatus) {
    case 'accepted/closed':
      return acceptedClosedConfig(isSuperNetwork, showProgramNameColumn);

    case 'accepted/open':
      return acceptedOpenConfig(isSuperNetwork, showProgramNameColumn);

    case 'in-review':
      return inReviewConfig(isSuperNetwork, showProgramNameColumn);

    case 'needs-action':
      return needsActionConfig(isSuperNetwork, showProgramNameColumn);

    case 'pending-consent':
      return pendingConsentConfig(actions, isSuperNetwork, showProgramNameColumn);

    case 'all':
    default:
      return allConfig(statuses, isSuperNetwork, currentSort, onSortColumn, showProgramNameColumn);
  }
}

export default getReferralColumnConfig;
